import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';

export const NO_LEN = 999999;

@Injectable()
export class CustomPaginatorIntl extends MatPaginatorIntl {
  itemsPerPageLabel = 'Elementi per pagina';

  getRangeLabel = (page: number, pageSize: number, length?: number): string => {
    if (pageSize === 0) {
      return `0`;
    }
    const startIndex = page * pageSize;
    let endIndex: number;
    if (length === undefined || length === 0) {
      endIndex = (page + 1) * pageSize;
    } else {
      endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
    }

    if (length === undefined || length === 0 || length === NO_LEN) {
      return `${startIndex + 1} - ${endIndex}`;
    }

    return `${startIndex + 1} - ${endIndex} di ${length}`;
  }

  updateLabels(labels: {
    itemsPerPageLabel?: string,
    getRangeLabel?: (page: number, pageSize: number, length?: number) => string
  }): void {
    if (labels.itemsPerPageLabel !== undefined) {
      this.itemsPerPageLabel = labels.itemsPerPageLabel;
    }
    if (labels.getRangeLabel !== undefined) {
      this.getRangeLabel = labels.getRangeLabel;
    }

    this.changes.next();
  }
}
